@import (reference) '../../../constants/spacing.module.less';

.sidebar-button {
  color: var(--default--icon--fill-color--10);
  cursor: pointer;
  height: 40px;
  width: 40px;
  padding: @space-8;
  border-radius: 4px;
  line-height: 1.5;

  &:hover {
    background-color: var(--order-details-canvas--header-buttons--focus--background-color);
    color: var(--order-details-canvas--header-buttons--focus--text-color);
  }

  &:active {
    background-color: var(--order-details-canvas--header-buttons--active--background-color);
    color: var(--order-details-canvas--header-buttons--active--text-color);
  }

  &:focus-visible {
    background-color: var(--order-details-canvas--header-buttons--focus--background-color);
    outline: 1px solid var(--tabs--tab-button--hover--text-color);
    box-shadow: 0 0 4px var(--tabs--tab-button--hover--text-color);
    color: var(--order-details-canvas--header-buttons--focus--text-color);
  }

  &.selected {
    background-color: var(--order-details-canvas--header-buttons--selected--background-color);
    color: var(--order-details-canvas--header-buttons--selected--text-color);
  }
}
